import { apiRequest } from '@/utils/api-request';
import { Test } from '@/types/evals-types';
import { useOrgStore } from '@/stores/org-store';

export const getTests = async (): Promise<Test[]> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  const response = await apiRequest<Test[]>({
    url: `/evaluations/tests/${orgId}`,
    target: 'platform',
    method: 'GET',
  });
  return response?.data as Test[];
};

export const getTestById = async (id: string): Promise<Test> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  const response = await apiRequest<Test>({
    url: `/evaluations/test/${orgId}/${id}`,
    target: 'platform',
    method: 'GET',
  });
  return response?.data as Test;
};
